// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import GameSelection from "./components/GameSelection";
import GameSession from "./components/GameSession";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import usePageTracking from "./usePageTracking";
import 'bootstrap/dist/css/bootstrap.min.css';

function PageTrackingWrapper() {
  usePageTracking();
  return null;
}

function App() {
  return (
    <Router>
      <PageTrackingWrapper /> {/* ✅ Fix is here */}
      <Navbar />
      <Routes>
        <Route path="/" element={<GameSelection />} />
        <Route path="/game-session/:gameName/:gameId" element={<GameSession />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;


